import { BiddingStrategies } from '../../../index'
import { PerformanceMode } from '../../../targets'

export interface Body {
    winner: KeywordFinal
    loser: KeywordFinal
    justification: ImprovementJustification
    performance_mode: PerformanceMode
    lookback_window: number
}

export interface ExtraDetails {
    winner: boolean // if true then pause/delete winner
    delete_keyword: boolean // if false or undefined then pause keyword
}

export interface KeywordFinal {
    bidding_strategy: BiddingStrategies.BiddingStrategy
    keyword: KeywordMatchTypeFinal
    metrics: {
        clicks: number
        cost_micros: number
        impressions: number
        all_conversions: number
        all_conversions_value: number
        quality_score: number
        ctr: number
        cpa: number
        roas: number
        days_with_impressions: number
    }
    campaign: {
        id: number
        name: string
    }
    ad_group: {
        id: number
        name: string
    }
    conversion_action_names: string[]
    above_minimum_clicks: boolean
}

export enum ImprovementJustification {
    LowerCpa = 'lower_cpa',
    HigherRoas = 'higher_roas',
    HigherProfit = 'higher_profit',
    NoQualityScore = 'no_quality_score',
    HigherCTR = 'higher_ctr',
    HigherImpressions = 'higher_impressions',
    HigherQualityScore = 'higher_quality_score',
}

export interface KeywordMatchTypeFinal extends KeywordMatchType {
    match_type: MatchType
}

export interface KeywordMatchType {
    text: string
    resource_name: string
    final_url: string | undefined
}

export type MatchType = 'BROAD' | 'EXACT' | 'PHRASE'
